import React from 'react';
import { useReactToPrint } from 'react-to-print';
import { IInitialState } from '../../../../../../redux/duck/legado/limitApp/interface/reduxInterfaces';
import DownloadBtn from '../../../../../../shared/components/buttons/DownloadButton';
import Pdf from '../../../../../../shared/components/icons/Pdf';
import ClientsPdfSheet from './components/ClientsPdfSheet';

function ExportPdf(data: IInitialState) {
  const componentRef: any = React.useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <div>
      <div style={{ display: 'none' }}>
        <ClientsPdfSheet
          data={data.limits}
          date={data.dateSearch}
          ref={componentRef}
        />
      </div>

      <DownloadBtn onClick={handlePrint}>
        <Pdf />
      </DownloadBtn>
    </div>
  );
}

export default ExportPdf;
